/**
 * What the bill details modal shows in its document pane, and in what order of precedence.
 *
 * Its own function because the order is the whole of it, and a chain of nested ternaries is where
 * getting it wrong hides: the missing state was originally asked last, so a bill the service had
 * said was gone went on displaying its document beside a banner saying it no longer existed
 * (LB-5897). One of those two was lying, and it was the document.
 */
export const BILL_PREVIEW = {
  /** The service says there is no such bill. Nothing else about it is worth showing. */
  missing: 'missing',
  /** The file this session uploaded, straight from the browser. */
  sessionBlob: 'sessionBlob',
  /** The stored document, behind a presigned url. */
  stored: 'stored',
  /** The bill is real and has no document behind it. */
  noDocument: 'noDocument',
  loading: 'loading'
};

/**
 * @param isMissing       the service answered 404 for this bill
 * @param sessionFileUrl  object url for a file uploaded in this session, when there is one
 * @param sourceStatus    'loading' | 'ready' | 'none' — how the stored document lookup went
 */
export function resolveBillPreview() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isMissing = _ref.isMissing,
    sessionFileUrl = _ref.sessionFileUrl,
    sourceStatus = _ref.sourceStatus;
  // First, and deliberately: both branches below can be satisfied by a bill that has since been
  // deleted — the blob is still in this browser, and a url already fetched is still in hand.
  if (isMissing) return BILL_PREVIEW.missing;
  if (sessionFileUrl) return BILL_PREVIEW.sessionBlob;
  if (sourceStatus === 'ready') return BILL_PREVIEW.stored;
  if (sourceStatus === 'none') return BILL_PREVIEW.noDocument;
  return BILL_PREVIEW.loading;
}